/* eslint-disable react-hooks/exhaustive-deps */
// Modules
import React, { useCallback, useEffect, useState } from 'react'

// Application
import { useActivateHook, useRecoverHook } from 'hooks'
import { Contact } from 'typings'

// Components
import { SelectContact, SelectContactInitial } from 'components/Presenters/SelectContact'
import { mapFromResetContacts } from 'utils/contacts'
import { ROUTES_PATH } from 'constants/routesPath'
import { useHistory } from 'react-router-dom'
import { BiometyDataType } from 'typings/unico'
import { UNICO_CONSTANTS } from 'redesign/constants'

export const SelectContactWrapper: React.VFC = () => {
    const recover = useRecoverHook()
    const history = useHistory()
    const activeAccount = useActivateHook()
    const [loading, setLoading] = useState(false)
    const [validatedContacts, setValidatedContacts] = useState<Contact[]>([])

    const { username } = recover
    const biometyDataLS: BiometyDataType = JSON.parse(sessionStorage.getItem(UNICO_CONSTANTS.STORAGE)!)

    const user = username || biometyDataLS?.federalTaxId

    const userFormated = user?.replace(/[^a-z0-9]/gi, '')

    const handleSubmit = async (values: SelectContactInitial) => {
        try {
            recover.setSubmitting(true)
            if (values.contact?.type) {
                !recover.username && recover.setUsername(biometyDataLS?.federalTaxId!)
                recover.setContact(values.contact)
                const { generateKeyOtp } = await recover.sendOTPToken(values.contact)
                recover.setOtpKey(generateKeyOtp.key)
                recover.nextStep(undefined, 'otp')
            }
        } catch (err) {
            recover.moveToError('/erro-de-conexao')
        } finally {
            recover.setSubmitting(false)
        }
    }

    const getContacts = useCallback(async () => {
        try {
            setLoading(true)
            const contactsToReset = await activeAccount.getContactsToReset(userFormated!)
            recover.setContacts(userFormated!, mapFromResetContacts(contactsToReset))

            setValidatedContacts(mapFromResetContacts(contactsToReset))

            setLoading(false)
        } catch (err) {
            const codeError = err.graphQLErrors[0]?.extensions.code
            codeError === 'NOT_FOUND' && history.replace(ROUTES_PATH.SIGN_IN)
        }
    }, [userFormated])

    useEffect(() => {
        getContacts()
    }, [])

    return (
        <SelectContact
            contacts={validatedContacts}
            handleSubmit={handleSubmit}
            initialValues={{ contact: validatedContacts[0] }}
            isLoading={loading}
            isSubmitting={recover.isSubmitting}
        />
    )
}
